import { isNil } from 'lodash'
import { useMemo } from 'react'

import { useLayout } from '@/layout/providers/LayoutProvider'
import { EnvironmentBanner } from '@/modules/shared/components/environment-banner/EnvironmentBanner'
import { MandateBanner } from '@/modules/shared/components/mandaat-banner/MandateBanner'
import { useSafeAreaColor } from '@/modules/shared/hooks/useSafeAreaColor'
import { ScreenType, useScreenType } from '@/modules/shared/hooks/useScreenType'
import { useLoggedInForMandatee } from '@/modules/trust/hooks/useLoggedInForMandatee'
import { DesktopPageLayout } from './DesktopPageLayout'
import { MobilePageLayout } from './MobilePageLayout'

import type { PageLayoutProps } from './PageLayout.types'

const PageLayout = ({ header, navigation, children }: PageLayoutProps) => {
  const { isNavigationVisible } = useLayout()
  const screenType = useScreenType()
  const isLoggedInForSomeoneElse = useLoggedInForMandatee()
  const safeAreaColor = useSafeAreaColor({ isLoggedInForSomeoneElse })

  const showNavigation = useMemo(() => isNavigationVisible && !isNil(navigation), [isNavigationVisible, navigation])

  const mandateBanner = isLoggedInForSomeoneElse ? <MandateBanner /> : null
  const environmentBanner = <EnvironmentBanner />

  if (!screenType) {
    return null
  }

  const commonProps = {
    header,
    navigation,
    children,
    showNavigation,
    mandateBanner,
    environmentBanner,
    safeAreaColor,
  }

  if (screenType === ScreenType.Mobile) {
    return <MobilePageLayout {...commonProps} />
  }

  return <DesktopPageLayout {...commonProps} />
}

export { PageLayout }
